import React from "react";
import PropTypes from "prop-types";
import { Col, Row, Card } from "react-bootstrap";
import { connect } from "react-redux";
import Scroll from "react-scroll";
import Skeleton from '@material-ui/lab/Skeleton';
import { setName } from "../../../../actions/gameChat";
import socket from "../../../../Socket";
import storage from "../../../../Storage";
import UserModal from "../../../Components/User/Stat/Modal";
import { getElement, __, wait, encode, decode, defaultAvatar, isUTF8, Event, sendNotfication } from "../../../../Helper";
import C from "../../../../Constant";

const Element = Scroll.Element;
const SC = Scroll.scroller;

class Messages extends React.Component {
    bubble = 'none';
    bubbleMsg = 0;
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            alertSpam: false,
            messages: [],
            loader: [],
            clientCountry: storage.getKey('country') ? storage.getKey('country') : "GLOBAL",
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.setLoader();

        wait(2500).then(() => {
            if (this._isMounted) {
                var c = this.state.clientCountry;
                socket.emit(C.CHATS, c);
            }
        });

        socket.on(C.CHATS, data => this.getChats((data)));
        socket.on(C.ADD_CHAT, data => this.getNewChats((data)));

        Event.on('scrolldone', () => this.updateScroll());
        this.updateScroll();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this._isMounted) {
            if (nextProps.country) {
                this.setState({ clientCountry: nextProps.country, messages: [] });
                this.setLoader();

                wait(500).then(() => {
                    if (this._isMounted) {
                        var c = nextProps.country;

                        if (__.lowerCase(c) === "spam") {
                            this.setState({ alertSpam: true });
                            Event.emit('open_socket');
                        }
                        else {
                            this.setState({ alertSpam: false });
                            Event.emit('close_socket');
                        }

                        socket.emit(C.CHATS, c);
                    }
                });
            }
            this.updateScroll();
        }
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (this._isMounted) {
            const suffix = this.props.suffix || 'default';
            const containerId = `messages-${suffix}`;
            let e = getElement(`#${containerId}`);
            if (e) {
                let t = e.clientHeight,
                    n = e.scrollHeight,
                    r = e.scrollTop;
                this.scrollBottom = n - r - t;
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this._isMounted) {
            this.updateScroll();
            if (this.state.messages.length >= 150) {
                var slice = __.slice(this.state.messages, this.state.messages.length - 1, this.state.messages.length);
                this.setState({ messages: slice })
                this.state.messages.length = 150;
            }
        }
    }

    updateScroll() {
        if (this._isMounted) {
            if (this.scrollBottom <= 150) {
                const suffix = this.props.suffix || 'default';
                const containerId = `messages-${suffix}`;
                const elementName = `chatBarElement-${suffix}`;
                const scId = `sc-${suffix}`;

                SC.scrollTo(elementName, {
                    delay: 3,
                    smooth: true,
                    containerId: containerId,
                    offset: getElement(`#${scId}`) ? getElement(`#${scId}`).scrollHeight * 2 : 0,
                });
                const bubble = getElement('.chat-bubble');
                if (bubble) bubble.classList.add('hidden');
                this.bubbleMsg = 0;
            }
            else {
                this.bubbleMsg += 1;
                if (this.bubbleMsg !== 0) {
                    const bubble = getElement('.chat-bubble');
                    if (bubble) bubble.classList.remove('hidden');
                }
            }
        }
    }

    setLoader = () => {
        if (this._isMounted) {
            const icon = <div className="ycenter"><div className="spinner-border text-info" role="status" /></div>;
            this.setState({ loader: icon })
        }
    };

    getChats(data) {
        if (this._isMounted) {
            this.setState({ messages: [], loader: [] });
            sortByTime(data).forEach((message, i) => {
                this.setState(state => ({ messages: [<Message t={this.props.t} key={i} keych={i} message={message} redux={this.props} />, ...state.messages] }));
            });
        }
    }

    getNewChats(message) {
        if (this._isMounted) {
            let add = this.state.messages.concat([
                <Message t={this.props.t} key={this.state.messages.length + 1} message={message} redux={this.props} />
            ]);
            this.setState({ messages: add });
        }
    }

    hideBubble = () => {
        if (this._isMounted) {
            const suffix = this.props.suffix || 'default';
            const containerId = `messages-${suffix}`;
            const elementName = `chatBarElement-${suffix}`;
            const scId = `sc-${suffix}`;

            SC.scrollTo(elementName, {
                delay: 3,
                smooth: true,
                containerId: containerId,
                offset: getElement(`#${scId}`) ? getElement(`#${scId}`).scrollHeight * 2 : 0,
            });
            const bubble = getElement('.chat-bubble');
            if (bubble) bubble.classList.add('hidden');
            this.bubbleMsg = 0;
        }
    }

    render() {
        const suffix = this.props.suffix || 'default';
        const elementName = `chatBarElement-${suffix}`;
        const scId = `sc-${suffix}`;

        return (
            <Element name={elementName}>
                <div className="chats-container" id={scId}>
                    <div onClick={this.hideBubble} className={'chat-bubble'}>
                        {this.bubbleMsg}
                    </div>
                    {this.state.loader}
                    {this.state.messages}
                </div>
            </Element>
        );
    }
}

class Message extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: storage.getKey('name')
        }
    }

    callUser(name) {
        Event.emit('call_user', '@' + name + ' ')
    }

    createMarkup(msg) {
        return { __html: msg };
    }

    isSharing = (value) => {
        if (__.isString(value)) {
            let test = value.substr(0, 5);
            if (test === '{"gam' || test === '{"uid')
                return true;
            else
                return false;
        }
        else
            return true;
    }

    render() {
        const { t, keych } = this.props;
        let { name, message, avatar, time, level, twitch } = this.props.message;
        let username = name;
        let style;
        let highlight = '';

        if (username === 'Support' || username === 'support' || username === 'SUPPORT') {
            style = { color: 'rgba(241, 113, 49, 1)' };
        }

        const isOwn = this.state.name === username;

        if (!this.isSharing(message)) {
            let r = new RegExp('@' + this.state.name + '(?:$|[^a-z0-9_\-])', 'i');
            if (this.state.name !== username && r.test(message)) {
                highlight += 'highlight-on';
            }

            var expression = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi;
            var regex = new RegExp(expression);
            if (message.match(regex)) {
                let hidden = t('link_is_hidden');
                message = <div dangerouslySetInnerHTML={this.createMarkup(`<span className="text-danger">[ ${hidden} ]</span>`)} />;
            }

            let check = __.words(message, /@([a-zA-Z0-9]+)/gi);
            if (!twitch) {
                if (check.length !== 0) {
                    for (let i = 0; i < check.length; i++) {
                        let username = check[i];
                        let link = <span key={i} className="text-success-2"> @<UserModal key={i} username={__.replace(username, '@', '')} cssClass="text-success-2" /></span>;
                        try {
                            message = message.split(" ").map((c) => (c === username ? link : " " + c));
                        } catch (e) { }
                    }
                }
            }
        }
        else {
            style = { width: '100%' };
            if (__.isString(message)) {
                message = JSON.parse(message);
            }
            var isLost = false;
            var profit = parseFloat(message.profit);
            if (profit === 0 || profit === 0.00000000) {
                isLost = true;
            }
            message = (
                <div className="share-result">
                    {isLost ?
                        <h4 className="text-danger text-center mt-0 mb-3">{t('lost')}</h4>
                        :
                        <h4 className="text-warning text-center mt-0 mb-3 trmg">
                            <img src="/assets/images/contest.png" className="img-fluid" style={{ width: 40 }} alt="contest" /> <br /> {t('winner')}
                        </h4>
                    }
                    <Row>
                        <Col md="6" sm="6">
                            <div className="text-success bg-soft-info rounded py-2">{message.result}x <br /> {t('result')}</div>
                        </Col>
                        <Col md="6" sm="6">
                            <div className="text-white bg-soft-info rounded py-2">
                                <img className="mini-coin-8 mr-1" src={'/assets/images/' + __.lowerCase(message.coin) + '.png'} alt="coin" />
                                {message.profit} <br /> {t('profit')}
                            </div>
                        </Col>
                        <Col md="12" sm="12">
                            <div className="bg-soft-info text-white rounded mt-3 py-2">ID: {message.gid}</div>
                        </Col>
                    </Row>
                </div>
            );
        }

        const colorClass = ["username-neon-cyan", "username-neon-magenta", "username-neon-yellow"][Math.abs(username.length % 3)];

        return (
            <div key={__.toString(keych)} className={`chat-part ${isOwn ? 'chat-own-message' : 'chat-other-message'} ${highlight}`}>
                <div className="chat-user-header">
                    <span className={`chat-username ${colorClass}`}>
                        <UserModal t={t} username={username} chat={true} />
                    </span>
                    <span className="chat-time">{time}</span>
                    {(!isOwn && !twitch) && (
                        <div className="chat-option">
                            <span onClick={() => this.callUser(username)} style={{ cursor: 'pointer', marginLeft: '5px' }}>@</span>
                        </div>
                    )}
                </div>
                <div className={`chat-bubble-root ${highlight}`} style={style}>
                    {message}
                </div>
            </div>
        );
    }
}

function sortByTime(input) {
    function r(c) {
        return c.sorter ? - c.sorter : null;
    }
    return __.sortBy(input, r);
}

Messages.propTypes = {
    country: PropTypes.string,
    suffix: PropTypes.string
};

const mapStateToProps = state => ({
    country: state.items.country
});

export default connect(mapStateToProps, { setName })(Messages);